export default "__VITE_ASSET__Cdhyp0Um__"